export default "__VITE_ASSET__abAHyqQ8__"